<template>
  <div
    class="columns is-centered  is-multiline"
  >
    <div class="column is-8 has-text-centered">
      <div class="box">
        <h2 class="title is-2">
          404 - Page not found
        </h2>
        The page you are trying to view does not exist or you do not have access to it.
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FourOFour',
  data() {
    return {};
  },
};
</script>
